<template>
  <Flex direction="column">
    <BaseInput
      v-model="emailAddress"
      :label="$t('global.email_address')"
      type="email"
      required
      v-test="'document-email-email'"
    />
    <BaseInput
      v-model="emailSubject"
      :label="$t('global.email_subject')"
      type="text"
      v-test="'document-email-subject'"
    />
    <BaseText
      color="secondary"
      size="s"
    >
      <span v-pre>{{ company_name }}</span>
      {{ $t('register.optional_subject') }}
    </BaseText>
    <BaseEditor
      v-model="editorContent"
      :height="editorHeight"
      :cloudinaryName="UploadedImageUsage.NewsletterContent"
      v-test="'document-email-editor'"
    />
    <BaseText
      color="secondary"
      size="s"
    >
      {{ $t('register.optional_message') }}
    </BaseText>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { UploadedImageUsage } from '@/types';

const props = defineProps<{
  emailAddress: string;
  emailSubject: string;
  editorContent: string;
  editorHeight?: number;
}>();

const emit = defineEmits<{
  (e: 'update:emailAddress', value: string): void;
  (e: 'update:emailSubject', value: string): void;
  (e: 'update:editorContent', value: string): void;
}>();

const emailAddress = computed({
  get: () => props.emailAddress,
  set: (value) => emit('update:emailAddress', value),
});

const emailSubject = computed({
  get: () => props.emailSubject,
  set: (value) => emit('update:emailSubject', value),
});

const editorContent = computed({
  get: () => props.editorContent,
  set: (value) => emit('update:editorContent', value),
});
</script>
